var choseSize = function choseSize() {
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.add-to-cart-plp');
    if (!form) return;
    var select = form.querySelector('select[name="id"]');
    var errorMessage = form.querySelector('.form-error-message');
    if (select && !select.value) {
      event.preventDefault();
      if (errorMessage) {
        errorMessage.style.display = 'block';
      }
      return;
    }
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
  });
  document.addEventListener('change', function (event) {
    var select = event.target.closest('select[name="id"]');
    if (!select) return;
    var form = select.closest('.add-to-cart-plp');
    var errorMessage = form === null || form === void 0 ? void 0 : form.querySelector('.form-error-message');
    if (errorMessage && select.value) {
      errorMessage.style.display = 'none';
    }
  });
};
export { choseSize };